import { call, put, takeLatest, all } from "redux-saga/effects";
import { message } from "antd";

import {
  FETCH_ACCOUNTS,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_ERROR,
  SEARCH_ACCOUNTS,
  SEARCH_ACCOUNTS_ERROR,
  SEARCH_ACCOUNTS_SUCCESS,
} from "../../actions/receptionist/accountsAction";

import { fetchAccountsAPI } from "../../../services/accounts-service";

function* fetchAccounts(accounts) {
  try {
    const response = yield call(
      fetchAccountsAPI,
      accounts.payload.requestPayload
    );

    if (response.success) {
      yield put({
        type: FETCH_ACCOUNTS_SUCCESS,
        payload: {
          data: response.data,
          tab: accounts.payload.tab,
          requestPayload: accounts.payload.requestPayload,
        },
      });
    } else {
      message.error("Failed to fetch accounts!");

      yield put({
        type: FETCH_ACCOUNTS_ERROR,
        payload: {
          error: response.error,
          tab: accounts.payload.tab,
          requestPayload: accounts.payload.requestPayload,
        },
      });
    }
  } catch (error) {
    message.error("Failed to fetch accounts!");

    yield put({
      type: FETCH_ACCOUNTS_ERROR,
      payload: {
        error,
        tab: accounts.payload.tab,
        requestPayload: accounts.payload.requestPayload,
      },
    });
  }
}

function* searchAccounts(accounts) {
  try {
    const response = yield call(fetchAccountsAPI, accounts.payload);

    if (response.success) {
      yield put({
        type: SEARCH_ACCOUNTS_SUCCESS,
        payload: response.data.insuranceOrganisations,
      });
    } else {
      message.error("Failed to search accounts!");

      yield put({ type: SEARCH_ACCOUNTS_ERROR, error: response.error });
    }
  } catch (error) {
    message.error("Failed to search accounts!");

    yield put({ type: SEARCH_ACCOUNTS_ERROR, error });
  }
}

function* accountsWatcher() {
  yield takeLatest(FETCH_ACCOUNTS, fetchAccounts);
  yield takeLatest(SEARCH_ACCOUNTS, searchAccounts);
}

export default function* rootSaga() {
  yield all([accountsWatcher()]);
}
